// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/AssignmentPolicy.yaml
// Generated: 2026-06-14T18:14:05.802Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateAssignmentPolicy, UpdateAssignmentPolicy, AssignmentPolicy } from '@/types/core/AssignmentPolicy';

/**
 * AssignmentPolicy Service
 * CRUD operations for AssignmentPolicy via the ABP API.
 */
export const assignmentPolicyService = new EntityService<AssignmentPolicy, CreateAssignmentPolicy, UpdateAssignmentPolicy>(
  '/api/core/assignmentpolicy',
  'AssignmentPolicy',
);
